import css from 'styled-jsx/css'

export const styles = css`
  .wrapper {
    margin: 16px;
    padding: 12px;

    background-color: #ffffff;

    border: 1px solid #eeeeee;
    box-sizing: border-box;
    border-radius: 16px;

    /* for the badge */
    position: relative;
    overflow: hidden;
  }

  .wrapper a[href]::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .layout {
    display: flex;
  }

  .layout > * + * {
    margin-left: 12px;
  }

  .layout .content-wrapper {
    flex-grow: 1;
  }

  .image-wrapper {
    width: 112px;
    height: 112px;
    border-radius: 12px;
    overflow: hidden;
    flex-shrink: 0;
  }

  .image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .content > * + * {
    margin-top: 6px;
  }

  .content > .type {
    font-weight: 600;
    font-size: 11px;
    line-height: 2;
    letter-spacing: 2.5px;
    color: #333333;
  }

  .content > .name {
    font-weight: normal;
    font-size: 14px;
    line-height: 1.5;
    color: #333333;
  }

  .action {
    align-self: flex-end;

    width: 100px;
    height: 32px;
    padding: 8px 12px;
    background-color: #eb5761;
    border-radius: 16px;

    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #ffffff;

    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .action :global(svg) {
    margin-right: 4px;
  }

  .action:active {
    opacity: 0.2;
  }

  .badge-wrapper {
    position: relative;
    top: -16px;
    left: -16px;
    width: 0;
    height: 0;
  }

  .wrapper :global(.icon) {
    color: #fff;
    position: absolute;
    top: 6px;
    left: 6px;
  }

  .badge {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 48px 48px 0 0;
    border-color: #eb5761 transparent transparent transparent;
    position: absolute;
    top: 0;
    left: 0;
  }

  .line-clamp-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
`
